import React from 'react';

interface FieldProps extends React.InputHTMLAttributes<HTMLInputElement> {
    label?: string;
}

/** Labelled text input — soft border, gentle green focus. */
export const Field: React.FC<FieldProps> = ({label, className = '', id, ...rest}) => {
    const inputId = id ?? (label ? `field-${label.replace(/\s+/g, '-').toLowerCase()}` : undefined);
    return (
        <div>
            {label && (
                <label htmlFor={inputId} className="mb-1.5 block text-sm font-semibold text-[#4f4f48]">
                    {label}
                </label>
            )}
            <input
                id={inputId}
                {...rest}
                className={`w-full rounded-xl border border-[#d3cdba] bg-white px-3.5 py-2.5 font-medium text-[#0a0a0a] transition-all placeholder:text-[#9a948a] focus:border-[#22c55e] focus:outline-none focus:ring-2 focus:ring-[#22c55e]/30 disabled:opacity-50 ${className}`}
            />
        </div>
    );
};

export default Field;
